var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    group = _require$doc$builders.group,
    line = _require$doc$builders.line,
    concat = _require$doc$builders.concat,
    indent = _require$doc$builders.indent;

var indentIfNecessaryBuilder = function indentIfNecessaryBuilder(path) {
  return function (doc) {
    var parentNode = path.getParentNode();
    if (parentNode.type === 'IfStatement') return doc;
    if (parentNode.type === 'ForStatement') return doc;
    if (parentNode.type === 'WhileStatement') return doc;
    if (parentNode.type === 'BinaryOperation') return doc;
    return indent(doc);
  };
};

module.exports = {
  match: function match(op) {
    return ['<', '>', '<=', '>=', '==', '!='].includes(op);
  },
  print: function print(node, path, _print) {
    var indentIfNecessary = indentIfNecessaryBuilder(path);
    return group(indentIfNecessary(concat([path.call(_print, 'left'), ' ', node.operator, line, path.call(_print, 'right')])));
  }
};